export interface StockItemOrderHistory {
  id: string;
  orderNo: string;
  orderDate: Date;
  customerKey: string;
  customerName: string;
  currencyCode: string;
  orderQuantity: number;
  orderPrice: number;
  orderValue: number;
  orderSterlingValue: number;
  orderStatus: string;
  despatchNoteNo: number;
  despatchQuantity: number;
  despatchDate: Date;
  invoiceNo: number;
  invoiceDate: Date;
  invoicePrice: number;
}
